module.exports = __webpack_public_path__ + "img/none-icon.3058719.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/none-icon.png
// module id = oB9Z
// module chunks = 1